import { render, staticRenderFns } from "./EditProblem.vue?vue&type=template&id=0ebe3b1a"
import script from "./EditProblem.vue?vue&type=script&lang=js"
export * from "./EditProblem.vue?vue&type=script&lang=js"
import style0 from "./EditProblem.vue?vue&type=style&index=0&id=0ebe3b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports